import { useMutationState } from '@tanstack/react-query';
import { apiMutationKeys } from '../apis/apiMutationKeys';
import type { SendOTPResponse } from '../apis/auth/auth.schemas';
import type { SendOTPParams } from '../apis/auth/sendOTP';
import { useGlobalStore } from '@/stores/store';

const useSendOTPMutationState = () => {
  const customerId = useGlobalStore((store) => store.authStore.customerId);
  const sendOTPMutationResponses = useMutationState({
    filters: {
      mutationKey: apiMutationKeys.sendOTP(customerId),
    },
    select: (mutation) => ({
      data: mutation.state.data as SendOTPResponse,
      variables: mutation.state.variables as SendOTPParams,
    }),
  });
  // Get the last mutation response from cache
  return sendOTPMutationResponses[sendOTPMutationResponses.length - 1];
};

export { useSendOTPMutationState };
